import { logger } from '../utils/logger';
import React, { useState, useEffect } from 'react';
import { makeAuthenticatedRequest } from '../utils/api';
import './QuestProgressPanel.css';

interface QuestProgress {
  combat: number;
  eliteCombat: number;
  crafting: number;
}

const QuestProgressPanel: React.FC = () => {
  const [progress, setProgress] = useState<QuestProgress | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadQuestProgress();
  }, []);

  const loadQuestProgress = async () => {
    try {
      const response = await makeAuthenticatedRequest('/town/quest-progress');
      if (response.ok) {
        const data = await response.json();
        setProgress(data);
      }
    } catch (err) {
      logger.error('Failed to load quest progress:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="quest-progress-panel">
        <h3>Quest Progress</h3>
        <p>Loading...</p>
      </div>
    );
  }

  if (!progress) return null;

  return (
    <div className="quest-progress-panel">
      <h3>Quest Progress</h3>
      <div className="progress-items">
        <div className="progress-item">
          <span className="progress-icon">⚔️</span>
          <span className="progress-label">Combat:</span>
          <span className="progress-value">{progress.combat}</span>
        </div>
        <div className="progress-item">
          <span className="progress-icon">👑</span>
          <span className="progress-label">Elite Combat:</span>
          <span className="progress-value">{progress.eliteCombat}</span>
        </div>
        <div className="progress-item">
          <span className="progress-icon">🔨</span>
          <span className="progress-label">Crafting:</span>
          <span className="progress-value">{progress.crafting}</span>
        </div>
      </div>
      <p className="progress-note">
        Progress is used to complete town quests. Defeat monsters, craft items, and complete activities to increase your progress!
      </p>
    </div>
  );
};

export default QuestProgressPanel;
